/* eslint-disable @typescript-eslint/naming-convention */
import type { Accordion } from '@ps/web-martech-cms-types';
import classNames from 'clsx';
import React, { useCallback, useState } from 'react';

import PanelItem from '../CMSPanel/PanelItem';

import styles from './CMSAccordion.scss';

const CMSAccordion: React.FC<Accordion> = ({ slides, theme, button_type, collapse_list }) => {
  const lite = theme === 'Lite';
  const [active, setActive] = useState<number | null>(collapse_list ? -1 : 0);
  const showHide = useCallback(
    (itemIndex: number) => setActive((active) => (itemIndex === active ? null : itemIndex)),
    []
  );

  return slides.length ? (
    <div
      className={classNames(styles.accordion, {
        [styles.accordionDefault]: !lite
      })}
    >
      {slides.map((slide, index) => {
        const { title, body } = slide.slide;
        return (
          <PanelItem
            key={index}
            body={body}
            expandedTitle={title}
            collapsedTitle={title}
            expanded={index === active}
            theme={theme}
            buttonType={button_type}
            onClick={() => showHide(index)}
          />
        );
      })}
    </div>
  ) : null;
};

export default CMSAccordion;
